import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "KisDefectCategories",
  components: { TreeViewSelection },
  data: () => ({
    editedItem: { title: "", responsiblePersons: [] },
    editDialog: false
  }),
  async mounted() {
    await this.$store.dispatch("getDefectCategories", {
      principal_id: this.currentPrincipal
    });
    await this.$store.dispatch("getAllUsers", {
      principal_id: this.currentPrincipal
    });
    await this.$store.dispatch("getPersons");
  },
  methods: {
    async editItem(category) {
      this.editedItem = category ?? {
        title: "",
        responsiblePersons: [],
        principal_id: this.currentPrincipal
      };
      this.editDialog = true;
    },
    async saveCategory() {
      if (this.editedItem._id) {
        await this.updateCategory(this.editedItem);
      } else {
        await this.createCategory(this.editedItem);
      }
      this.editedItem = { title: "", responsiblePersons: [] };
      this.editDialog = false;
    },
    async createCategory(category) {
      const headers = getTokenHeader();
      const response = await axios.post(
        `${env.kis_api_client_url}defectCategory`,
        category,
        { headers }
      );
      if (response.status === 201) {
        await this.$store.dispatch("createSuccess", "Erfolgreich erstellt");
        await this.$store.dispatch("getDefectCategories");
      } else {
        await this.$store.dispatch(
          "createError",
          "Es ist ein Fehler aufgetreten"
        );
      }
    },
    async updateCategory(category) {
      const headers = getTokenHeader();
      const response = await axios.put(
        `${env.kis_api_client_url}defectCategory/${category._id}`,
        category,
        { headers }
      );
      if (response.status === 200) {
        await this.$store.dispatch("createSuccess", "Erfolgreich aktualisiert");
        await this.$store.dispatch("getDefectCategories");
      } else {
        await this.$store.dispatch(
          "createError",
          "Es ist ein Fehler aufgetreten"
        );
      }
    },
    async deleteCategory(category) {
      const confirm = await this.$confirm(
        "Möchten Sie diese Kategorie wirklich löschen?",
        confirmWarningConfig
      );
      if (confirm) {
        const headers = getTokenHeader();
        const response = await axios.delete(
          `${env.kis_api_client_url}defectCategory/${category._id}`,
          {
            params: { principal_id: this.currentPrincipal },
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch("createSuccess", "Erfolgreich gelöscht");
          await this.$store.dispatch("getDefectCategories");
        } else {
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten"
          );
        }
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    defectCategories() {
      return this.$store.state.defectCategories;
    },
    persons() {
      return (
        this.$store.state.users
          ?.filter(
            user =>
              !!user.roles.find(
                role =>
                  role.category.id === "00000000-0000-0000-0000-119000000000"
              )
          )
          ?.map(user => ({
            ...user,
            title: `${user.first_name} ${user.last_name}`
          })) || []
      );
    }
  }
};
